import React from 'react';
import { ReactComponent as DropDownIcon } from 'Assets/svg/dropdown-icon.svg';
import ReactHookSelect from 'react-hook-select';

const renderDropDownIcon = ({ isDropDownOpen }) => {
  return <DropDownIcon className={isDropDownOpen ? 'open' : ''} />;
};

const Select = props => {
  const {
    options,
    value = '',
    onChange,
    enableMultiple = false,
    inlineLabel = true,
    label = '',
    wrapperClassName = '',
    ...remainingProps
  } = props;

  return (
    <div className={`select-with-label ${wrapperClassName}`.trim()}>
      {!inlineLabel && label !== '' && (
        <label className="select-label">{label}</label>
      )}
      <ReactHookSelect
        renderDropDownIcon={renderDropDownIcon}
        options={options}
        enableMultiple={enableMultiple}
        value={value ? (Array.isArray(value) ? value : [value]) : []}
        getValue={newValue => {
          onChange(enableMultiple ? newValue : newValue[0]);
        }}
        {...(inlineLabel ? { label } : {})}
        {...remainingProps}
      />
    </div>
  );
};

export default Select;
